import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsFooter from "@events-awards/components/EventsAwardsFooter";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import GalleryItem from "@events-awards/EventsAwardsGallery/components/EventsAwardsGalleryItem";
import { EventsAwardsGalleryPageData } from "@events-awards/EventsAwardsGallery/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";
import { useLoadMoreEventsGallery } from "@hooks/useLoadMoreEventsGallery";

/**
 * Component to render gallery page for event and awards
 */
const EventsAwardsGalleryPageContent = ({
  articles,
  awardType,
  year,
  gaProps,
}: EventsAwardsGalleryPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  const { articleList, hasMoreArticles, ref } = useLoadMoreEventsGallery(
    articles,
    8,
    awardType,
    year
  );

  if (!articles) return <></>;

  return (
    <div
      className="min-h-screen w-full bg-gray-50"
      data-testid="events-awards-gallery-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <Row>
          <Column rootClassName="w-full">
            <EventsAwardsNavigationBar awardType={awardType} />

            <BlockTitle
              text="Gallery"
              rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium text-left font-poppins"
            />

            <div className="mx-auto py-8">
              <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
                {articleList?.map(({ id, title, elements, urlPath }) => (
                  <GalleryItem
                    key={id || title || ""}
                    link={urlPath || ""}
                    title={title || ""}
                    elements={elements || []}
                  />
                ))}
              </div>

              {hasMoreArticles ? (
                <div
                  ref={ref}
                  data-testid="events-awards-gallery-load-more-ref"
                />
              ) : null}
            </div>
          </Column>
        </Row>
      </Container>

      <EventsAwardsFooter awardType={awardType} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsGalleryPageContent;
